import { render, staticRenderFns } from "./SupervisorV2.vue?vue&type=template&id=78269ce3&scoped=true&"
import script from "./SupervisorV2.vue?vue&type=script&lang=ts&"
export * from "./SupervisorV2.vue?vue&type=script&lang=ts&"
import style0 from "./SupervisorV2.vue?vue&type=style&index=0&id=78269ce3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78269ce3",
  null
  
)

export default component.exports